import { useSession } from 'next-auth/react'
import { useEffect } from 'react'

const REFRESH_BUFFER_MS = 30 * 60 * 1000
export const REFETCH_INTERVAL_WHEN_EXPIRED_SECONDS = 60

export const RefreshTokenHandler = ({ setInterval }: { setInterval: (timeRemaining: number) => void }) => {
  const { data: session } = useSession()

  useEffect(() => {
    if (session) {
      const timeRemaining = Math.round((session.accessTokenExpiry - REFRESH_BUFFER_MS - Date.now()) / 1000)

      setInterval(timeRemaining > 0 ? timeRemaining : REFETCH_INTERVAL_WHEN_EXPIRED_SECONDS)
    }
  }, [session, setInterval])

  return null
}
